/**
 * Wraps an async fn so concurrent calls share one in-flight promise.
 * The slot clears once the promise settles, so later calls re-invoke.
 * @param {(...args: any[]) => Promise<any>} fn
 * @returns {(...args: any[]) => Promise<any>}
 */
export function singleFlight(fn) {
  let inFlight = null

  return function (...args) {
    inFlight ??= Promise.resolve(fn.apply(this, args)).finally(() => {
      inFlight = null
    })

    return inFlight
  }
}
